<template>
  <div class="policies">
    <div class="page__header">
      <div class="page__title">{{ $t(`policies.${"title"}`) }}</div>
      <div class="page__right">
        <div class="selected-filters" v-if="selectedTeams.length > 0 || Object.keys(searchPoliciesForms).length > 0">

          <div class="selected-filters__filter" v-for="teamId in selectedTeams" :key="`team${teamId}`">
            <span>
              Team: {{
                (loggedUser.teams && loggedUser.teams.find(t => t.id == teamId))
                  ? loggedUser.teams.find(t => t.id == teamId).name
                  : 'Team ' + teamId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeTeam(teamId)"></div>
          </div>

          <div class="selected-filters__filter" v-if="startDateFrom || startDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyStartDate"}`) }}: {{ formatDateShort(startDateFrom) || '...' }} -
              {{ formatDateShort(startDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearStartDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="endDateFrom || endDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyEndDate"}`) }}: {{ formatDateShort(endDateFrom) || '...' }} - {{
              formatDateShort(endDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearEndDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="submitDateFrom || submitDateTo">
            <span>{{ $t(`searchCustomerFields.${"policySubmitDate"}`) }}: {{ formatDateShort(submitDateFrom) || '...' }}
              - {{ formatDateShort(submitDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearSubmitDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-for="agentId in selectedAgents" :key="`agent${agentId}`">
            <span>
              {{
                (searchPoliciesForms.agents && searchPoliciesForms.agents.find(a => a.id == agentId))
                  ? searchPoliciesForms.agents.find(a => a.id == agentId).first_name + ' ' +
                  searchPoliciesForms.agents.find(a => a.id == agentId).last_name
                  : 'Agent ' + agentId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeAgent(agentId)"></div>
          </div>

          <div class="selected-filters__filter" v-for="companyId in selectedCompanies" :key="`company${companyId}`">
            {{
              searchPoliciesForms.companies.find(
                (item) => item.id === companyId
              ).name
            }}
            <div class="selected-filters__remove" @click="removeCompany(companyId)"></div>
          </div>

          <div class="selected-filters__filter" v-for="statusId in selectedPolicyStatuses" :key="`status${statusId}`">
            <span>{{
              searchPoliciesForms.policyStatuses.find(
                (item) => item.id === statusId
              )[`long_${language}`]
            }}</span>
            <div class="selected-filters__remove" @click="removePolicyStatus(statusId)"></div>
          </div>
        </div>

        <form class="search search--filter" @submit.prevent="keywordsSearch()">
          <div class="search__wrapper">
            <input class="search__search" ref="search" :class="{ 'search__search--active': searchKeywords }" type="text"
              v-model="searchKeywords" />
            <div class="search__icon"></div>
            <div class="search__splitter"></div>
          </div>
          <div class="search__filter" ref="filterToggler" @click="showSearchFilter = !showSearchFilter"></div>
          <SearchFilter v-if="showSearchFilter" :searchType="'policy'" :filterToggler="$refs.filterToggler"
            :toggleSearchFilter="(state) => {
              showSearchFilter = state;
            }
              " />
        </form>
      </div>
    </div>

    <div class="customers__content">
      <Loading v-if="policiesLoading" />
      <div v-else>
        <NoData style="height: 80vh;" :type="'policiesList'" v-if="policiesPerPage.data.length == 0" />
        <div v-else class="table">
          <div class="table__header box box--default">
            <div class="table__label table__label--small" style="padding-right: 0 !important;"></div>
            <div class="table__label table__label--large">
              {{ $t(`policies.${"tableHead"}.${"insurance"}`) }}
            </div>

            <div class="table__label table__label--medium">
              {{ $t(`policies.${"tableHead"}.${"plateNr"}`) }}
            </div>

            <div class="table__label table__label--large">
              {{ $t(`policies.${"tableHead"}.${"company"}`) }}
            </div>
            <div class="table__label table__label--small">
              {{ $t(`policies.${"tableHead"}.${"status"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`policies.${"tableHead"}.${"customer"}`) }}
            </div>
            <div class="table__label table__label--medium">
              {{ $t(`policies.${"tableHead"}.${"policyNr"}`) }}
            </div>
            <div class="table__label table__label--medium">
              {{ $t(`policies.${"tableHead"}.${"created"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`policies.${"tableHead"}.${"agent"}`) }}
            </div>
            <div class="table__label table__label--small" style="padding: 0 !important;">
            </div>
            <div class="table__label table__label--small" style="padding: 0 !important;">
            </div>

          </div>

          <div class="table__body">
            <div class="row policy-row row--hover box box--default" v-for="policy in policiesPerPage.data"
              :key="policy.id" :class="[policy.policy_status ? `policy--${policy.policy_status.long_en}` : '']"
              @click="goToCustomer(policy.customer, policy.customer_id, policy.id)">
              <div class="row__data row__data--small policy-icon" style="padding-right: 0 !important;"> 
                <div :class="[
                  'icon',
                  `icon__policy--${policy.policy_services.find(s => s.service && s.service.id === selectedPolicies[policy.id])
                    ? policy.policy_services.find(s => s.service && s.service.id === selectedPolicies[policy.id]).service.branch_category.id
                    : 'krankenkasse'
                  }`
                ]">
                </div>
              </div>

              <div class="row__data row__data--large">
                <div v-if="policy.policy_services && policy.policy_services.length > 0"
                  style="width: 100%;  text-align: center;">
                  <VSelect @click.stop v-if="policy.policy_services.length > 1" style="width: 100%; background: 0;"
                    :options="policy.policy_services.filter(s => s.service && s.service.branch_category).map(s => ({
                      label: s.service.branch_category.name,
                      value: s.service.id
                    }))" label="label" :reduce="option => option.value"
                    class="select select--default customer__dropdown" v-model="selectedPolicies[policy.id]" />

                  <span v-else>
                    {{ policy.policy_services[0].service && policy.policy_services[0].service.branch_category ?
                      policy.policy_services[0].service.branch_category.name : '------' }}
                  </span>

                </div>
                <span v-else>------</span>
              </div>

              <div class="row__data row__data--name row__data--medium">
                <span v-if="policy.plate_number">{{ policy.plate_number }} </span>
                <span v-else>------</span>
              </div>


              <div class="row__data row__data--name row__data--large">
                <div v-if="policy.company">
                  <p>{{ policy.company.full_name }}</p>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--small">
                <div v-if="policy.policy_status">
                  <p>{{ policy.policy_status.name }}</p>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--name row__data--large">
                <div v-if="policy.customer">
                  <span v-if="policy.customer.company_name">
                    {{ policy.customer.company_name }}
                  </span>
                  <span v-else>
                    {{ policy.customer.first_name }} {{ policy.customer.last_name }}
                  </span>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--medium">
                <div v-if="policy.policy_number">
                  <p>{{ policy.policy_number }}</p>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--medium">
                <div>
                  <p>{{ formatDate(policy.created_at) }}</p>
                </div>
              </div>
              <div class="row__data row__data--name row__data--large">
                <div v-if="policy.agent">
                  {{ policy.agent.first_name }} {{ policy.agent.last_name }}
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--small row__data--pdf" @click.stop style="padding: 0 !important;">
                <div @click="openPolicyFilesModal(policy.id, policy.policy_files)" class="icon icon__pdf"
                  :class="{ 'icon__pdf--active': policy.policy_files.length }"></div>
              </div>
              <div class="row__data row__data--action row__data--small" style="padding: 0 !important;"></div>
            </div>
          </div>

          <Pagination :limit="3" :data="policiesPerPage" @pagination-change-page="getResults"></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from "vuex";
import SearchFilter from "@/partials/SearchFilter";
//import RowActionDropdown from "@/components/RowActionDropdown";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";
export default {
  components: {
    SearchFilter,
    NoData,
    Loading,
    //RowActionDropdown
  },
  data() {
    return {
      searchPlaceholder: "",
      searchKeywords: "",
      showSearchFilter: false,
      selectedTeams: [],
      selectedAgents: [],
      selectedCompanyTypes: [],
      selectedCompanies: [],
      selectedBranchCategories: [],
      selectedPolicyStatuses: [],
      selectedPolicies: {},
      startDateFrom: "",
      startDateTo: "",
      endDateFrom: "",
      endDateTo: "",
      submitDateFrom: "",
      submitDateTo: "",
      initialLoadDone: false,
    }
  },
  watch: {
    'policiesPerPage.data': {
      handler(newPolicies) {
        if (!newPolicies || !Array.isArray(newPolicies)) return;

        newPolicies.forEach(policy => {
          if (!this.selectedPolicies[policy.id] && policy.policy_services.length > 0) {
            this.selectedPolicies[policy.id] = policy.policy_services[0].service.id;
          }
        });
      },
      deep: true,
      immediate: true
    },

    "$route.query": {
      async handler(query, oldQuery) {

        if (!query.page) {
          this.$router.replace({
            query: { ...query, page: 1 },
          }).catch(() => { });
          return;
        }

        if (oldQuery && JSON.stringify(query) === JSON.stringify(oldQuery)) {
          return;
        }

        this.loadFiltersFromQuery(query);

        await this.searchPolicies();

        this.initialLoadDone = true;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      "policiesPerPage",
      "policiesLoading",
      "searchPoliciesForms",
      "loggedUser",
    ]),
  },
  async created() {
    if (!(this.$checkRolePermission('customer_access') || this.$checkRolePermission('customer_show'))) {
      this.$router.push('/dashboard');
      return;
    }

    try {
      const teams = this.$route.query.teams ?
        this.$route.query.teams.split(",").map(Number) :
        (this.loggedUser.teams?.length === 1 ? [this.loggedUser.teams[0].id] : []);

      if (teams.length > 0) {
        await this.$store.dispatch("getSearchPoliciesForms", teams);
      }
    } catch (e) {
      console.error("Form Load Error", e);
    }
  },
  methods: {
    async searchPolicies() {
      this.$store.commit("setPoliciesLoading", true);

      const q = this.$route.query;
      const page = Number(q.page) || 1;

      const teams = q.teams ? q.teams.split(",").map(Number) : [];
      const agents = q.agents ? q.agents.split(",").map(Number) : [];
      const companies = q.companies ? q.companies.split(",").map(Number) : [];
      const policyStatuses = q.policyStatuses ? q.policyStatuses.split(",").map(Number) : [];
      const branchCategories = q.branchCategories ? q.branchCategories.split(",").map(Number) : [];

      try {
        await this.$store.dispatch("searchPolicies", {
          page,
          teams,
          agents,
          companies,
          branchCategories,
          policyStatuses,
          search: q.search || "",
          startDateFrom: q.startDateFrom || "",
          startDateTo: q.startDateTo || "",
          endDateFrom: q.endDateFrom || "",
          endDateTo: q.endDateTo || "",
          submitDateFrom: q.submitDateFrom || "",
          submitDateTo: q.submitDateTo || "",
        });
      } finally {
        this.$store.commit("setPoliciesLoading", false);
      }
    },


    async loadFiltersFromQuery(q) {
      this.searchKeywords = q.search || "";
      this.selectedTeams = q.teams ? q.teams.split(",").map(Number) : [];
      this.selectedAgents = q.agents ? q.agents.split(",").map(Number) : [];
      this.selectedCompanies = q.companies ? q.companies.split(",").map(Number) : [];
      this.selectedBranchCategories = q.branchCategories ? q.branchCategories.split(",").map(Number) : [];
      this.selectedPolicyStatuses = q.policyStatuses ? q.policyStatuses.split(",").map(Number) : [];
      this.startDateFrom = q.startDateFrom || "";
      this.startDateTo = q.startDateTo || "";
      this.endDateFrom = q.endDateFrom || "";
      this.endDateTo = q.endDateTo || "";
      this.submitDateFrom = q.submitDateFrom || "";
      this.submitDateTo = q.submitDateTo || "";
    },

    removePolicyStatus(id) {
      this.selectedPolicyStatuses = this.selectedPolicyStatuses.filter((x) => x !== id);
      this.updateQuery();
    },

    removeAgent(id) {
      this.selectedAgents = this.selectedAgents.filter((x) => x !== id);
      this.updateQuery();
    },

    removeCompany(id) {
      this.selectedCompanies = this.selectedCompanies.filter((x) => x !== id);
      this.updateQuery();
    },

    removeBranchCategory(id) {
      this.selectedBranchCategories = this.selectedBranchCategories.filter(
        (x) => x !== id
      );
      this.updateQuery();
    },

    clearStartDateRange() {
      this.startDateFrom = "";
      this.startDateTo = "";
      this.updateQuery();
    },

    clearEndDateRange() {
      this.endDateFrom = "";
      this.endDateTo = "";
      this.updateQuery();
    },

    clearSubmitDateRange() {
      this.submitDateFrom = "";
      this.submitDateTo = "";
      this.updateQuery();
    },

    removeTeam(id) {
      this.selectedTeams = this.selectedTeams.filter((x) => x !== id);

      if (this.selectedTeams.length === 0) {
        this.clearAllDependentFilters();
      }

      this.updateQuery();
    },

    clearAllDependentFilters() {
      this.selectedAgents = [];
      this.selectedCompanies = [];
      this.selectedBranchCategories = [];
      this.selectedPolicyStatuses = [];
      this.startDateFrom = "";
      this.startDateTo = "";
      this.endDateFrom = "";
      this.endDateTo = "";
      this.submitDateFrom = "";
      this.submitDateTo = "";

      this.$store.commit("setSearchPoliciesForms", {});
    },

    // !!FUTURE CHANGE
    goToCustomer(customer, customerId, policyId) {
      if (customer && customer.id) {
        this.$router.push(`/account-details/customer/${customer.id}/policy/${policyId}`);
      } else {
        this.$router.push(`/account-details/customer/${customerId}/policy/${policyId}`);
      }
    },
    // goToCustomer(policy, id){
    //   if(policy && policy.customer){
    //     this.$router.push(`/account-details/customer/${policy.customer.id}`);
    //   }else{
    //     this.$router.push(`/account-details/customer/${id}`);
    //   }
    // },


    openPolicyFilesModal(id, files) {
      this.$store.commit("setPolicyFileId", id);
      this.$store.commit("setPolicyFiles", files);
      this.$store.commit("setShowPolicyFilesModal", true);
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },

    formatDateShort(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);

      return `${day}/${month}/${year}`;
    },

    updateQuery() {
      const query = {
        page: 1,
        search: this.searchKeywords || undefined,
        teams: this.selectedTeams.length ? this.selectedTeams.join(",") : undefined,
        agents: this.selectedAgents.length ? this.selectedAgents.join(",") : undefined,
        companies: this.selectedCompanies.length ? this.selectedCompanies.join(",") : undefined,
        branchCategories: this.selectedBranchCategories.length ? this.selectedBranchCategories.join(",") : undefined,
        policyStatuses: this.selectedPolicyStatuses.length ? this.selectedPolicyStatuses.join(",") : undefined,
        startDateFrom: this.startDateFrom || undefined,
        startDateTo: this.startDateTo || undefined,
        endDateFrom: this.endDateFrom || undefined,
        endDateTo: this.endDateTo || undefined,
        submitDateFrom: this.submitDateFrom || undefined,
        submitDateTo: this.submitDateTo || undefined,
      };

      this.$router.replace({ query }).catch(() => { });
    },

    async getResults(paginationPage) {
      this.$router.replace({
        query: { ...this.$route.query, page: paginationPage },
      });
    },

    async keywordsSearch() {
      this.updateQuery();
    },
  }
}
</script>


<style lang="scss" scoped>
.policy-row {
  position: relative;

  &::before {
    position: absolute;
    z-index: 3;
    content: "";
    left: 0;
    top: -1px;
    height: calc(100% + 2px);
    width: 15px;
    border-top-left-radius: var(--radius-1);
    border-bottom-left-radius: var(--radius-1);
  }
}

.policy--Active {
  &::before {
    background-color: #22DB8E;
  }
}

.policy--Submitted,
.policy--Processing {
  &::before {
    background-color: #FF9E0F;
  }
}

.policy--Inactive {
  &::before {
    background-color: #DB2222;
  }
}

.page__right {
  display: flex;
  gap: 20px;

  .button--default {
    width: 200px;
  }
}
</style>